if (!customElements.get('koko-balm-application')) {
  customElements.define('koko-balm-application', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[role="tabpanel"]')];
      const photos = [...this.querySelectorAll('[data-application-photo]')];
      const dots = [...this.querySelectorAll('.koko-balm-application__dots span')];
      if (!tabs.length) return;
      let current = Math.max(0, tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true'));
      const select = (index, focus = false) => {
        current = (index + tabs.length) % tabs.length;
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === current));
          tab.tabIndex = i === current ? 0 : -1;
          panels[i].hidden = i !== current;
          photos[i]?.classList.toggle('is-active', i === current);
          dots[i]?.classList.toggle('is-active', i === current);
        });
        if (focus) tabs[current].focus({ preventScroll: true });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index), { signal });
        tab.addEventListener('keydown', event => {
          const targets = { ArrowRight: current + 1, ArrowDown: current + 1, ArrowLeft: current - 1, ArrowUp: current - 1, Home: 0, End: tabs.length - 1 };
          if (!(event.key in targets)) return;
          event.preventDefault();
          select(targets[event.key], true);
        }, { signal });
      });
      this.querySelector('[data-application-next]')?.addEventListener('click', () => select(current + 1), { signal });
      this.addEventListener('shopify:block:select', event => {
        const tab = event.target.closest('[data-application-step]');
        if (tab) select(Number(tab.dataset.applicationStep));
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
